export const FALLBACK_BACKGROUND_COLOR = '#f4f3f3';
export const SPECIAL_CATEGORY_NAME = 'Your Jiffy';
